import { useSiteMetadata } from './site-metadata-hook';

export const useGoogleTagManagerId = (): string => {
  return useSiteMetadata().googleTagManagerId;
};
